/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-19 12:14:03
 * @LastEditors: Jack Deng
 * @LastEditTime: 2023-03-14 17:43:04
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductReview/ProductReviewDetail/index.tsx
 */
import Layout from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
import React, { useContext } from 'react';

import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Button, Modal } from 'src/components/Antd';
import AddNew from './AddReview';
import ProductInfo from './ProductInfo';
import Reviews from './Reviews';
import css from './css.module.less';
import {
  fetchSpecReview,
  getProduct,
  getSalesChannel,
  postSpecReview,
  resetData,
} from './slice';
//import { Icon } from '@/src/tools/icon';
import { msg } from '@/src/tools/message';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import Export, { EnumScope } from 'src/constrains/Export';
import Import from 'src/constrains/Import';
import ModalHOC from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { exportReviews } from 'src/request/review';
import { isUserValid, storeResourceNameGenerator } from 'src/tools/getUserInfo';
import { convertRes2Blob } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';
export const EditModalContext = React.createContext(null);
const WrappedEditModal = (Comp) => {
  const WComp = (props) => {
    const i18n = useI18n();
    const getI18n = (str) => i18nGet(i18n, str);
    const [visible, setVisible] = React.useState(false);
    const [data, setData] = React.useState(null);
    const _d = useDispatch();
    const handleOnCancel = () => {
      setVisible(false);
      setData(null);
    };

    const handleOnEdit = (data) => {
      setData(data);
      setVisible(true);
    };

    const handleOnSubmit = (e) => {
      _d(postSpecReview({ review: e }));
      handleOnCancel();
    };
    return (
      <EditModalContext.Provider
        value={{
          onEdit: handleOnEdit,
          onCancel: handleOnCancel,
          // setCollapseOpen: _setCollapseOpen,
          // setReplyOpen: _setReplyOpen,
          // replyOpen,
        }}>
        {visible && (
          <Modal
            width={600}
            visible={visible}
            title={getI18n(
              'reviews.productreview.productReviewDetail_genaral_add_btn',
            )}
            footer={null}
            className={css.modal}
            onCancel={handleOnCancel}>
            <AddNew
              onCancel={handleOnCancel}
              onOk={handleOnSubmit}
              {...(data || {})}
            />
          </Modal>
        )}

        <Comp {...props} />
      </EditModalContext.Provider>
    );
  };
  return WComp;
};

const ProductReview = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const breadcrumbData = [
    {
      url: '/',
      name: getI18n('general.sider.home'),
    },
    {
      url: '/reviewList',
      name: getI18n('reviews.productreview.productReviewList_pageLayoutProps'),
    },
    ,
  ];
  const _p: { productUuid: string } = useParams();
  const _d = useDispatch();
  const _h = useHistory();
  const { productUuid } = _p;

  const getData = () => {
    _d(fetchSpecReview({ productUuid }));
  };

  React.useEffect(() => {
    getData();
    return () => {
      _d(resetData());
    };
  }, []);

  const Child = React.useMemo(() => {
    if (true) {
      return [
        { element: ProductInfo, id: 'ProductInfo' },
        { element: Reviews, id: 'Reviews' },
      ];
    } else {
      return [];
    }
  }, []);
  return (
    <React.Fragment>
      <Layout
        topLeft={
          <TopLeft
            goBack={() => {
              _h.push('/reviewList');
            }}
            breadcrumbData={breadcrumbData}
          />
        }
        topRight={<TopRight productUuid={productUuid} updatePage={getData} />} //topRight={topRight}
        elements={Child}
      />
    </React.Fragment>
  );
};
export default WrappedEditModal(ProductReview);

const TopRight = ModalHOC((props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const canAddReview = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Products,
        subCategory: EnumSubCategory.ProductsReview,
        operation: EnumOperation.add_edit_review,
      }),
    ],
  });
  const { modalOp, productUuid, updatePage } = props;
  const { setShowModal, setModalTitle, setModalContent } = modalOp;
  const onModalCancel = () => {
    setShowModal(false);
    setModalContent(null);
  };
  const onExport = (data: any) => {
    const { uuid, ...rest } = data;
    const re = { ...rest, productUuids: uuid };
    _export(re);
  };

  const _export = (re) => {
    exportReviews(re).then((res: any) => {
      convertRes2Blob(res);
      onModalCancel();

      msg.success(getI18n('general.done'));
    });
  };

  const exportFun = () => {
    setShowModal(true);
    setModalContent(
      <Export
        scopeList={[EnumScope.Current, EnumScope.All]}
        currentUuid={[productUuid]}
        onCancel={onModalCancel}
        onExport={onExport}
        defaultScope={EnumScope.Current}
      />,
    );

    setModalTitle(
      getI18n('reviews.productreview.productReviewDetail_genaral_exportreview'),
    );
  };
  const importOnSuccess = () => {
    updatePage();
    onModalCancel();
    //refresh
  };
  const importFun = () => {
    setShowModal(true);
    setModalContent(
      <Import onCancel={onModalCancel} onSuccess={importOnSuccess} />,
    );
    setModalTitle(
      getI18n('reviews.productreview.productReviewDetail_genaral_importreview'),
    );
  };

  const { onEdit } = useContext(EditModalContext);
  const sales = useSelector(getSalesChannel());
  const product = useSelector(getProduct());
  const handleOnAddNewClick = () => {
    if (onEdit)
      onEdit({
        productReviewSalesChannels: sales,
        storeUuid: '1',
        staffUuid: '2',
        product,
      });
  };

  return (
    <div className={css.topRightContainer}>
      <Button
        onClick={importFun}
        icon={<DownloadOutlined />}
        className={css.import}>
        {getI18n('general.import')}
      </Button>
      <Button
        onClick={exportFun}
        icon={<UploadOutlined />}
        className={css.export}>
        {getI18n('general.export')}
      </Button>
      {canAddReview && (
        <Button
          onClick={handleOnAddNewClick}
          type='primary'
          className={css.addReviewButton}>
          {getI18n('reviews.productreview.productReviewDetail_genaral_add_btn')}
        </Button>
      )}

      {/* <Button
        className={css.btnLeft}
        icon={<Icon type='iconright' className={css.leftIcon} />}
      />
      <Button className={css.btnRight} icon={<Icon type='iconright' />} /> */}
    </div>
  );
});
